module.exports = __webpack_public_path__ + "static/media/speech_04.aa7a4aac.svg";